import BlogHero from './components/BlogHero';
import BlogGrid from './components/BlogGrid';
import MoringaSpotlight from './components/MoringaSpotlight';
import SEO from '../../components/SEO';

export default function Blog() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Blog',
        name: 'MY AVA Farms Blog — Moringa Health Tips & BSF Farming Insights',
        description: 'Health tips, moringa recipes, Black Soldier Fly farming insights and sustainability stories from MY AVA Farms in Accra, Ghana.',
        url: `${siteUrl}/blog`,
        publisher: {
          '@type': 'Organization',
          name: 'MY AVA Farms',
          url: siteUrl,
          logo: {
            '@type': 'ImageObject',
            url: 'https://static.readdy.ai/image/3ca3a64fdbdd1a27f61611d5a6ab11d4/19d8f85f961deb0bcb56f566b071f178.jpeg',
          },
        },
      },
      {
        '@type': 'BlogPosting',
        headline: 'Moringa Powder Dosage Guide: How Much to Take, When & What to Expect',
        description: 'Complete guide to moringa powder dosage for adults, children, elderly, and pregnant women. Learn how much pure moringa to take daily for maximum health benefits in Ghana.',
        url: `${siteUrl}/blog`,
        datePublished: '2026-03-01',
        dateModified: '2026-03-25',
        author: {
          '@type': 'Organization',
          name: 'MY AVA Farms',
          url: siteUrl,
        },
        publisher: {
          '@type': 'Organization',
          name: 'MY AVA Farms',
          url: siteUrl,
          logo: {
            '@type': 'ImageObject',
            url: 'https://static.readdy.ai/image/3ca3a64fdbdd1a27f61611d5a6ab11d4/19d8f85f961deb0bcb56f566b071f178.jpeg',
          },
        },
        keywords: 'moringa dosage, moringa powder benefits, pure moringa Ghana, how much moringa to take, moringa health guide',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': `${siteUrl}/blog`,
        },
        image: 'https://public.readdy.ai/ai/img_res/9df79821f7938ecef672e407b89f35ee.jpg',
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: siteUrl,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'Blog',
            item: `${siteUrl}/blog`,
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEO
        title="Moringa Tips, Recipes & BSF Insights | MY AVA Farms Ghana"
        description="Read practical moringa health tips, Ghanaian moringa recipes, Black Soldier Fly farming insights, and sustainability stories from MY AVA Farms in Accra, Ghana. Learn how pure moringa powder can transform your health."
        keywords="moringa health tips Ghana, moringa recipes, pure moringa powder benefits, BSF farming insights, sustainable agriculture Ghana, moringa for children, moringa daily diet"
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <BlogHero />
        <MoringaSpotlight />
        <BlogGrid />
      </div>
    </>
  );
}
